<div class="toolbar" [ngClass]="showToolbar ? '': 'hide'">

  <div class="flex-col">
    <mat-form-field>
      <mat-select matNativeControl
                  panelClass="layerPanel"
                  class="form-control item layerNames"
                  [value]="(parameterList.length && selectedParameter)? selectedParameter :'no_value'"
                  (selectionChange)="changeParameter(layerSelect.value)"
                  name="layer"
                  #layerSelect>
        <mat-option *ngIf="!parameterList.length" value="no_value">----</mat-option>
        <mat-option [value]="layer"
                    *ngFor="let layer of parameterList">{{layer.name}}</mat-option>

      </mat-select>
    </mat-form-field>

    <div class="flex-al-center">
      <mat-label>Opacity</mat-label>
      <mat-slider

        class="opacity-slider"
        min="0"
        max="1"
        step="0.1"
        [ngModel]="layerOpacity"
        (ngModelChange)="changeAlpha($event)"></mat-slider>
    </div>

    <mat-form-field>
      <mat-label>Fly To</mat-label>
      <mat-select matNativeControl
                  panelClass="modelPanel"

                  class="form-control item fly-to"
                  (selectionChange)="flyTo(flyToSelection.value)"
                  #flyToSelection
                  name="flyto">
        <mat-option value="0">{{flyToList[0].name}}</mat-option>
        <mat-option value="1">{{flyToList[1].name}}</mat-option>
        <mat-option value="2">{{flyToList[2].name}}</mat-option>
        <mat-option value="3">Fly through the alps</mat-option>
      </mat-select>
    </mat-form-field>
    <!--        <button (click)="getPosition()">get location</button>-->


  </div>

  <!--  <br>-->

  <div class="time-control" *ngIf="!isSmallScreen">
    <div class="nav-time-box">
      <button class="small"
              mat-stroked-button

              (click)="timeBack()">
        <i class="material-icons">
          keyboard_arrow_left
        </i></button>
      <button class="small"
              mat-stroked-button

              (click)="timeForth()">
        <i class="material-icons">
          keyboard_arrow_right
        </i></button>
    </div>
    <label>{{formatDate(selectedTime, 'll HH:mm')}}</label>

    <div *ngIf="currentTimeRange" class="time-slider">
      <mat-slider type="range"
                  [color]="'primary'"
                  min="0"

                  [max]="currentTimeRange.length - 1"
                  step="1"
                  id="time-slider-input"
                  [ngModel]="idxOfTime"
                  (ngModelChange)="changeTime($event)"></mat-slider>
    </div>

  </div>
  <div class="flex-center-center">
    <a mat-stroked-button class="" href="/en/weather-api/">
      Free trial account
    </a>
  </div>
  <div>
    <p>Check out all parameters <a href="/en/api/overview/">here</a></p>
  </div>

</div>


<div *ngIf="!isSmallScreen && (selectedParameter && selectedParameter.name !== 'sat_rgb:idx')"
     class="legend-box" [class.legend-size]="showLegend">
  <img *ngIf="showLegend && legendUrl"
       class="legend"
       [src]="legendUrl"
       [alt]="legendUrl">
  <i *ngIf="!showLegend" (click)="showLegend = true" class="material-icons">
    color_lens
  </i>
  <a *ngIf="showLegend" (click)="showLegend = false"
     class="legend-popup-closer"></a>
</div>

<div *ngIf="!isSmallScreen && loadingGlobe"
     class="spinner-loading-tiles">
  <mat-spinner [strokeWidth]="4" color="spinner" [diameter]=32></mat-spinner>
</div>


<div class="time-control-mobile" *ngIf="isSmallScreen && settingsData">

  <div *ngIf="showLegend  && (selectedParameter && selectedParameter.name !== 'sat_rgb:idx')"
       class="mobile-legend-box">
    <img *ngIf="showLegend && legendUrl"
         (click)="showLegend = false"
         class="legend"
         [src]="legendUrl"
         [alt]="legendUrl">
    <a *ngIf="isSmallScreen"
       (click)="showLegend = false"
       class="legend-popup-closer"></a>
  </div>

  <div class="api-info-mobile">
    <div class="power-by"><span><a
      class="free-trial-btn"
      href="/en/weather-api/">Weather API powered by</a></span></div>
    <span class="flex-center-center"><a
      href="/en/weather-api/"><img alt="meteomatics logo" src="./assets/meteomatics-logo.svg"></a>&nbsp;</span>
  </div>


  <div class="legend-info-image2" *ngIf="selectedParameter.name !== 'sat_rgb:idx'"
       (click)="showLegend = !showLegend">
    <i class="material-icons">
      color_lens
    </i>
  </div>

  <div *ngIf="loadingGlobe"
       class="spinner-loading-tiles-mobile">
    <mat-spinner [strokeWidth]="4" color="spinner" [diameter]=32></mat-spinner>
  </div>


  <div class="minimize-setting-btn"
       (click)="showOnlyHeaders(tabGroupMobile)">
    <i class="material-icons">
      menu
    </i>
  </div>


  <mat-tab-group [class.hide]="hideTabContent"
                 (click)="hideTabContent = false"
                 #tabGroupMobile mat-stretch-tabs>
    <mat-tab #layerTab [label]="(!hideTabContent && layerTab.isActive) ? 'Layer' :  selectedParameter.name">
      <div class="tab-content-layer">
        <div class="flex-al-center full-width">

          <mat-form-field class="layer-select-mobile">
            <mat-select matNativeControl
                        id="layer"
                        panelClass="layerPanel"
                        class="form-control item layerNames"
                        [value]="(parameterList.length && selectedParameter)? selectedParameter :'no_value'"
                        (selectionChange)="changeParameter(layerSelect.value)"
                        name="layer"
                        #layerSelect>
              <mat-option *ngIf="!parameterList.length" value="no_value">----</mat-option>
              <mat-option [value]="layer"
                          *ngFor="let layer of parameterList">{{layer.name}}</mat-option>

            </mat-select>
          </mat-form-field>

          <mat-form-field class="">
            <mat-label>Fly To</mat-label>
            <mat-select matNativeControl
                        panelClass="modelPanel"
                        class="form-control item fly-to"
                        (selectionChange)="flyTo(flyToSelection.value)"
                        #flyToSelection
                        name="flyto">
              <mat-option value="0">{{flyToList[0].name}}</mat-option>
              <mat-option value="1">{{flyToList[1].name}}</mat-option>
              <mat-option value="2">{{flyToList[2].name}}</mat-option>
              <mat-option value="3">Fly through the alps</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-al-center full-width">
          <mat-label>Opacity</mat-label>
          <mat-slider id="opacity"
                      class="opacity-slider"
                      min="0"
                      max="1"
                      step="0.1"
                      [ngModel]="layerOpacity"
                      (ngModelChange)="changeAlpha($event)"></mat-slider>
        </div>
        <div class="flex-al-center full-width">
          <p>Check out all parameters <a href="/en/api/overview/">here</a></p>
        </div>
      </div>
    </mat-tab>
    <mat-tab #timeTab [label]="(!hideTabContent && timeTab.isActive) ? 'Time' :  formatDate(selectedTime, 'll HH:mm')">
      <div class="tab-content-time">
        <div class="time-slider-mobile">
          <mat-slider type="range"
                      [color]="'primary'"
                      min="0"
                      [max]="currentTimeRange.length - 1"
                      step="1"
                      id="time-slider-input-mobile"
                      [ngModel]="idxOfTime"
                      (ngModelChange)="changeTime($event)"></mat-slider>
        </div>

        <label>{{formatDate(selectedTime, 'll HH:mm')}}</label>
        <div class="nav-time-box">
          <button class=""
                  mat-stroked-button
                  (click)="timeBack()">
            <i class="material-icons">
              keyboard_arrow_left
            </i></button>
          <button class=""
                  mat-stroked-button
                  (click)="timeForth()">
            <i class="material-icons">
              keyboard_arrow_right
            </i></button>
        </div>

      </div>
    </mat-tab>
  </mat-tab-group>
</div>


<app-chart-box class="chart-box" *ngIf="chartOptions"
               [optionsH]="chartOptions"
               cdkDragBoundary=".chart-boundary"
               cdkDrag></app-chart-box>

<div *ngIf="!isSmallScreen" class="api-info">
  <span class="flex-col-center">
    <a class="free-trial-btn"
       href="/en/weather-api/">Weather API powered by</a><a class="free-trial-btn"
                                                            href="/en/weather-api/">
      <img alt="meteomatics logo" src="./assets/meteomatics-logo.svg">
    </a>
  </span>
</div>




